import { Button, Typography } from '@mui/material'
import { FunctionComponent, useContext } from 'react'
import ThirdPartyConnectionDetailsService from '../../shared-services/third-party-connection-details/third-party-connection.service'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications'

export const RevokeTokenButton: FunctionComponent<{
  provider: string,
}> = ({ provider }) => {

  const thirdPartyConnectionDetailsService = new ThirdPartyConnectionDetailsService()
  const userNotificationsContext = useContext(UserNotificationsContext)

  const revokeTokenHandler = () => {
    userNotificationsContext.openDialog({ active: true, title: 'Confirmation', message: `Are you sure you want to disconnect from this provider?`, buttonCopy: 'Continue', cancelButtonCopy: 'Cancel' })
      .then(response => {
        if (response) {
          thirdPartyConnectionDetailsService.revokeToken(provider)
            .then(() => {
              window.location.reload()
            })
            .catch(err => {
              console.log(err)
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
            })
        }
      })
  }

  return (
    <>
      <Button
        onClick={() => revokeTokenHandler()}
        sx={{ minWidth: '100px', mr: 2 }}
        variant='outlined'
      >
        <Typography>
          {`Disconnect from ${provider.charAt(0).toUpperCase() + provider.slice(1).toLowerCase()}`}
        </Typography>
      </Button>
    </>
  )
}